module.exports = {
    FOXES_CREATE_BRIEF: 3021,
    QUALAS_USER_PAGE_LOYALTY_BANNER: 3104
};
